module.exports = [
  {
    id: 1,
    locale: 'pl',
    label: 'PL',
    default: true
  }
];
